export const formatDateToString = (date: string, withYear = false) => {
  if (!date) return;

  // First try direct Date parsing - this is safer as it handles more formats
  const DATE = new Date(date);

  // Ensure we got a valid date
  if (isNaN(DATE.getTime())) {
    return;
  }

  if (withYear) {
    return DATE.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC", // Ensure we interpret the date in UTC
    });
  }
  return DATE.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC", // Ensure we interpret the date in UTC
  });
};

export default formatDateToString;
